import { httpProxy } from '../api';
import type { StartTechnicalAnalysisPayload } from '@/types/technical-analysis';

/**
 * Start a technical analysis for a brand.
 * Returns jobId for polling.
 */
async function startTechnicalAnalysis(brandId: number, payload?: StartTechnicalAnalysisPayload) {
  console.log('[technical-analysis] Calling POST brand/:brandId/technical-analysis', { brandId, payload });
  const body = payload?.analyzers?.length
    ? { analyzers: payload.analyzers }
    : {};
  const response = await httpProxy.post(`brand/${brandId}/technical-analysis`, body);
  console.log('[technical-analysis] POST technical-analysis result:', response?.data);
  return response;
}

/**
 * Get job status and result (for polling).
 * @param lang Language for content rehydration (e.g., "en", "es", "ca").
 */
async function getTechnicalAnalysisJob(jobId: string, lang?: string) {
  console.log('[technical-analysis] Calling GET brand/technical-analysis/:jobId', { jobId, lang });
  const params = lang ? `?lang=${lang}` : '';
  const response = await httpProxy.get(`brand/technical-analysis/${jobId}${params}`);
  console.log('[technical-analysis] GET job result:', response?.data);
  return response;
}

/**
 * Get the latest completed technical analysis for a brand.
 * @param lang Language for content rehydration (e.g., "en", "es", "ca").
 */
async function getLatestTechnicalAnalysis(brandId: number, lang?: string) {
  console.log('[technical-analysis] Calling GET brand/:brandId/technical-analysis/latest', { brandId, lang });
  const params = lang ? `?lang=${lang}` : '';
  const response = await httpProxy.get(`brand/${brandId}/technical-analysis/latest${params}`);
  console.log('[technical-analysis] GET latest result:', response?.data);
  return response;
}

/**
 * Get technical analysis history for charts.
 * @param days Optional, default 30 on backend.
 * @param lang Language for content rehydration (e.g., "en", "es", "ca").
 */
async function getTechnicalAnalysisHistory(brandId: number, days?: number, lang?: string) {
  const queryParams = new URLSearchParams();
  if (days != null) queryParams.set('days', String(days));
  if (lang) queryParams.set('lang', lang);
  const qs = queryParams.toString();
  const url = qs ? `brand/${brandId}/technical-analysis/history?${qs}` : `brand/${brandId}/technical-analysis/history`;
  console.log('[technical-analysis] Calling GET brand/:brandId/technical-analysis/history', { brandId, days, lang });
  const response = await httpProxy.get(url);
  console.log('[technical-analysis] GET history result:', response?.data);
  return response;
}

export default {
  startTechnicalAnalysis,
  getTechnicalAnalysisJob,
  getLatestTechnicalAnalysis,
  getTechnicalAnalysisHistory
};
